/* eslint-disable */
import FlexMasonry from 'flexmasonry/src/flexmasonry';

Drupal.behaviors.masonryDiv = {
  attach(context) {
    function demoLayout() {
      const demoItems = context.querySelectorAll('.video__wrap');

      let timer = 100;
      demoItems.forEach(function (item) {
        const min = 200;
        const max = 400;
        const height = Math.floor(Math.random() * (max - min + 1) + min);
        item.style.height = height + 'px';

        item.classList.remove('appear');
        setTimeout(function () {
          item.classList.add('appear');
        }, timer);

        timer += 25;
      });
    }
    demoLayout();
    FlexMasonry.init('.masonry', {
      responsive: true,
      breakpointCols: {
        'min-width: 1500px': 3,
        'min-width: 1200px': 3,
        'min-width: 992px': 3,
        'min-width: 768px': 2,
        'min-width: 576px': 2,
      },
    });
  },
};
